export default {
  type: 'storelocator',
  aliases: ['store-locator'],
  slices: []
};